<div>
    <span *ngFor="let auth of authors" class="ccsauthors">{{auth.name[0]}}. {{auth.surname}} </span>
</div>